module.exports = __webpack_public_path__ + "img/emoji_98.04701d46.png";